var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanktransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.4 2.59999L19.3999 98.6C5.39987 104.6 -2.40013 119.6 0.699869 134.4C3.79987 149.2 16.7999 160 31.9999 160V168C31.9999 181.3 42.6999 192 55.9999 192H456C469.3 192 480 181.3 480 168V160C495.2 160 508.3 149.3 511.3 134.4C514.3 119.5 506.5 104.5 492.6 98.6L268.6 2.59999C260.6 -0.800012 251.4 -0.800012 243.4 2.59999ZM128 224H63.9999V420.3C63.3999 420.6 62.7999 421 62.1999 421.4L14.1999 453.4C2.49987 461.2 -2.80013 475.8 1.29987 489.3C5.39987 502.8 17.8999 512 31.9999 512H480C494.1 512 506.5 502.8 510.6 489.3C514.7 475.8 509.5 461.2 497.7 453.4L449.7 421.4C449.1 421 448.5 420.7 447.9 420.3L448 224H384V416H344V224H280V416H232V224H168V416H128V224ZM256 64C264.487 64 272.626 67.3714 278.627 73.3726C284.628 79.3737 288 87.5131 288 96C288 104.487 284.628 112.626 278.627 118.627C272.626 124.629 264.487 128 256 128C247.513 128 239.374 124.629 233.372 118.627C227.371 112.626 224 104.487 224 96C224 87.5131 227.371 79.3737 233.372 73.3726C239.374 67.3714 247.513 64 256 64Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanktransfer);
export default __webpack_public_path__ + "static/media/banktransfer.769e72c3c0bd049bbf9c0da7aa982c61.svg";
export { ForwardRef as ReactComponent };